import { AzureCustomizationsDark } from '@uifabric/azure-themes';
import { Theme } from '@fluentui/theme';

export const AzureDarkTheme: Theme = AzureCustomizationsDark.settings.theme;
